/**
 * @spec docs/specs/features/staking-position-ui.md#wallet-integration
 * Wallet status button that opens the wallet drawer
 */
import { cn } from '@/lib/cn';
import { useSelectedWallet } from '@/hooks/useSelectedWallet';
import { WalletAddress } from '@/components/ui/WalletAddress';
import WalletIcon from '@/assets/icons/wallet.svg?react';

export interface WalletStatusProps {
  /** Custom className for the container */
  className?: string;
  /** Callback to open the wallet drawer */
  onOpenDrawer?: () => void;
  /** Whether the wallet drawer is currently open */
  isDrawerOpen?: boolean;
}

/**
 * Displays the connected wallet address as a button that opens the wallet drawer
 */
export function WalletStatus({ className, onOpenDrawer, isDrawerOpen }: WalletStatusProps) {
  const { address } = useSelectedWallet();

  if (!address) {
    return null;
  }

  return (
    <button
      onClick={onOpenDrawer}
      className={cn(
        'flex items-center gap-2',
        'rounded-lg bg-bg-secondary px-3 py-2 border border-border',
        isDrawerOpen ? 'pointer-events-none' : 'transition-colors hover:border-border-hover',
        className
      )}
      aria-label="Open wallet drawer"
      type="button"
    >
      <WalletIcon className="h-4 w-4 text-accent-purple" />
      <WalletAddress address={address} className="text-text-primary" />
    </button>
  );
}
